import { axiosAdapter } from 'foca-openapi/adapters/axios';
import http from './http';
import { OpenapiClientPump } from 'src/openapi/pump';

export const pumpApi = new OpenapiClientPump(axiosAdapter(http, (res) => res));
